import { render, staticRenderFns } from "./ClinicIndex.vue?vue&type=template&id=e75ff06a&scoped=true&"
import script from "./ClinicIndex.vue?vue&type=script&lang=js&"
export * from "./ClinicIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e75ff06a",
  null
  
)

export default component.exports